import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { SharedService } from '../shared.service';
import { PublicFunding } from 'src/app/core/models/PublicFunding';
import { UIControlTyp } from 'src/app/core/models/UIControlTyp';

@Component({
  standalone: false,
  selector: 'fdb-public-funding',
  templateUrl: './public-funding.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./public-funding.component.scss']
})
export class PublicFundingComponent implements OnInit {
  public UIControlTyp = UIControlTyp;
  public SelectedPublicFundingIds: number[] = [];
  /** Hiermit können Sie den UIControlTyp entscheiden => Default DropDownList */
  @Input() uiController: UIControlTyp = UIControlTyp.DropDownList;
  // tslint:disable-next-line: no-input-rename
  @Input('values')
  get values() {
    const val = this.uiController === UIControlTyp.MultiSelectList ?
      this.SelectedPublicFundingIds :
      Number(this.PublicFunding ? this.PublicFunding.id : 0);
    return val;
  }
  set values(val: number | (string | number)[]) {
    if (Array.isArray(val)) {
      this.SelectedPublicFundingIds = this.normalizeIds(val);
      this.getRefreshSelectedValue();
      this.refreshPublicFundingList();
    } else {
      this.PublicFunding = this.getObjectFromList(val as number);
    }
  }
  @Output() valuesChange = new EventEmitter();

  /** Enthält die ausgewählten Werte bei UIControlTyp.MultiSelectList */
  public PublicFundings: PublicFunding[] = [];
  /** Enthält die ausgewählten Wert bei UIControlTyp.DropDownList */
  public PublicFunding: PublicFunding;
  /** Enthält die Werte die angezeigt werden dürfen */
  public PublicFundingList: PublicFunding[] = [];
  /** Enthält die Originalliste mit allen Werten */
  private OriginalValues: PublicFunding[] = [];

  constructor(private modulService: SharedService, private cdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.initPublicFunding();
  }

  initPublicFunding() {
    this.modulService.getPublicFundings(true)
      .subscribe(apiResult => {
        if (!apiResult.isSuccessful) {
          this.modulService.showNotification(apiResult.message, 'error');
        }
        if (apiResult.payload) {
          this.OriginalValues = apiResult.payload;
          this.refreshPublicFundingList();
          this.getRefreshSelectedValue();
          this.rebindSelectedPublicFundingIds();
          this.cdRef.detectChanges();
        }
      },
      err => this.modulService.showNotification(err, 'error'));
  }

  filterPublicFundingList(value: string) {
    this.refreshPublicFundingList(value);
  }

  valueChanged(event?: (string | number)[]): void {
    if (this.uiController === UIControlTyp.MultiSelectList) {
      this.SelectedPublicFundingIds = this.normalizeIds(event || this.SelectedPublicFundingIds);
      this.getRefreshSelectedValue();
      this.refreshPublicFundingList();
    }
    this.valuesChange.emit(this.values);
  }

  getObjectFromList(id: number): PublicFunding {
    if (id === 0 || isNaN(id)) {
      return new PublicFunding().getEmptyModel();
    }

    const find = this.OriginalValues.find(unit => Number(unit.id) === id);
    return find ? find : new PublicFunding().setId(id);
  }
  getName() {
    const find = this.getObjectFromList(Number(this.PublicFunding ? this.PublicFunding.id : 0));
    return find ? find.name : '';
  }
  getRefreshSelectedValue() {
    this.PublicFundings = this.SelectedPublicFundingIds
      .map(id => this.OriginalValues.find(y => Number(y.id) === Number(id)) || new PublicFunding().setId(id));
  }

  private rebindSelectedPublicFundingIds() {
    this.SelectedPublicFundingIds = [...this.SelectedPublicFundingIds];
    setTimeout(() => {
      this.SelectedPublicFundingIds = [...this.SelectedPublicFundingIds];
    });
  }

  private normalizeIds(values: (string | number)[]): number[] {
    return values
      .map(x => Number(x))
      .filter(x => !isNaN(x) && x > 0);
  }

  private refreshPublicFundingList(filterValue: string = '') {
    const filter = filterValue.toLowerCase();
    const activeValues = this.OriginalValues
      .filter(s => s.isActive === true)
      .filter(s => filter === '' || (s.name || '').toLowerCase().indexOf(filter) !== -1);
    const selectedValues = this.SelectedPublicFundingIds
      .map(id => this.OriginalValues.find(x => Number(x.id) === Number(id)))
      .filter(x => !!x);
    this.PublicFundingList = this.mergeById(activeValues, selectedValues as PublicFunding[]);

    if (this.uiController === UIControlTyp.DropDownList) {
      this.PublicFundingList.unshift(new PublicFunding().getEmptyModel());
    }
  }

  private mergeById(first: PublicFunding[], second: PublicFunding[]): PublicFunding[] {
    const map: { [key: number]: PublicFunding } = {};
    first.forEach(x => map[Number(x.id)] = x);
    second.forEach(x => map[Number(x.id)] = x);
    return Object.keys(map).map(key => map[Number(key)]);
  }
}
